import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { UserManager, User } from 'oidc-client';
import { AppConfig } from './app.config';
import { IRole, IRoleResponse } from '../models/authorization.model';
import { of, Subject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  private apiUrl = 'api/user';
  private _userManager: UserManager;

  private roles: IRole[] = [];

  constructor(private http: HttpClient) {
    const stsSettings = {
      authority: AppConfig.settings.ID4.AuthAddress,
      client_id: AppConfig.settings.ID4.Client,
      redirect_uri: AppConfig.settings.ID4.Redirect,
      scope: 'openid RNapi',
      response_type: 'code',
      post_logout_redirect_uri: AppConfig.settings.ID4.Post_Logout,
      loadUserInfo: false
    };

    this._userManager = new UserManager(stsSettings);
  }

  private canAddNote = new Subject<boolean>();
  canAddNote$ = this.canAddNote.asObservable();

  private canAddApp = new Subject<boolean>();
  canAddApp$ = this.canAddApp.asObservable();

  canAddNotes(perm: boolean) {
    this.canAddNote.next(perm);
  }

  canAddApps(perm: boolean) {
    this.canAddApp.next(perm);
  }

  public getUserRoles = (): Promise<void> => {
    return new Promise((resolve) => {
      try {
        this._userManager.getUser().then((user) => {
          if (!(user == null)) {
            const url = `${this.apiUrl}/${user.profile?.sub}`;
            if (this.roles && this.roles.length >= 1) {
              this.setRolePermissions();
              resolve();
            } else {
              this.http.get<IRoleResponse>(url, { withCredentials: false }).toPromise().then((data) => {
                this.roles = data.data;
                this.setRolePermissions();
                resolve();
              });
            }
          } else {console.log(`NULL USER`);}
        });
      }
      catch (e) {
        console.log(e);
      }
    });
  }

  private setRolePermissions = (): void => {
    this.canAddNotes(this.roles.some((role) => role.roleDescription?.toLowerCase().trim() == 'noteentry'));
    this.canAddApps(this.roles.some((role) => role.roleDescription?.toLowerCase().trim() == 'applicationentry'));
  }

  private handleError(err: HttpErrorResponse) {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
